import { render, staticRenderFns } from "./acceptance.vue?vue&type=template&id=16ac785b&scoped=true"
import script from "./acceptance.vue?vue&type=script&lang=js"
export * from "./acceptance.vue?vue&type=script&lang=js"
import style0 from "./acceptance.vue?vue&type=style&index=0&id=16ac785b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac785b",
  null
  
)

export default component.exports